import React, { useCallback } from 'react'
import {
  SummaryBannerContainer,
  SummaryBannerText,
  SummaryBannerLink,
  SummaryBannerIconContainer,
} from './CarpartsCreditCardStyles.css'
import GTM from '../../helpers/GTM'

const CPPlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2453_24838)">
      <path d="M9.39637 3.65503L10.0997 0H8.55917L7.88969 3.47881C7.6082 5.01741 8.51204 6.35227 10.2023 6.35227H13.6937L13.9995 4.79295H10.3152C9.68683 4.79295 9.27541 4.28353 9.39628 3.65503H9.39637Z" fill="#59C369" />
      <path d="M4.6032 9.60544L3.89984 13.2605H5.4404L6.10988 9.78166C6.39137 8.24306 5.48753 6.9082 3.79727 6.9082H0.30576L0 8.46752H3.68424C4.31265 8.46752 4.72407 8.97694 4.6032 9.60544Z" fill="#59C369" />
      <path d="M13.6007 6.8614L10.0761 6.85888C8.26739 6.85748 7.02727 5.39065 7.3754 3.58176L8.06467 0H6.4878L5.7514 3.82676C5.73255 3.92467 5.71948 4.02192 5.71202 4.11824C5.68971 4.4072 5.71827 4.68711 5.79518 4.94639C5.80367 4.97513 5.79574 5.00472 5.77866 5.02871C5.75019 5.06856 5.69652 5.09273 5.6521 5.0708C5.35511 4.92455 5.01472 4.84643 4.65082 4.84643H0.68555L0.38623 6.40183L3.91087 6.40435C5.71958 6.40575 6.9597 7.87257 6.61156 9.68147L5.9223 13.2631H7.49916L8.23556 9.43637C8.25442 9.33847 8.26748 9.24121 8.27495 9.14489C8.29726 8.85593 8.2687 8.57603 8.19179 8.31675C8.18227 8.28455 8.19403 8.25188 8.2154 8.22668C8.24499 8.19187 8.29371 8.17199 8.33496 8.19233C8.63195 8.33859 8.97234 8.41671 9.33624 8.41671H13.3014L13.6007 6.86131V6.8614Z" fill="#59C369" />
    </g>
    <defs>
      <clipPath id="clip0_2453_24838">
        <rect width="14" height="13.2633" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

type CarpartsCreditCardSummaryBannerProps = {
  hasAllItemsFreeShippingForMembers?: boolean
  itemCount?: number
}

export const CarpartsCreditCardSummaryBanner: React.FC<CarpartsCreditCardSummaryBannerProps> = ({
  hasAllItemsFreeShippingForMembers = false,
  itemCount = 0,
}) => {
  const renderBannerText = () => {
    if (hasAllItemsFreeShippingForMembers) {
      if (itemCount === 1) {
        return (
          <>
            This item ships
            {' '}
            <b>FREE</b>
            {' '}
            with CarParts+
          </>
        )
      }
      return (
        <>
          These items ship
          {' '}
          <b>FREE</b>
          {' '}
          with CarParts+
        </>
      )
    }
    return (
      <>
        Some items ship
        {' '}
        <b>FREE</b>
        {' '}
        with CarParts+
      </>
    )
  }

  const onClick = useCallback(() => {
    GTM?.membershipCartAboveOrderSummaryBannerLearnMoreEngaged()
  }, [])

  return (
    <SummaryBannerContainer>
      <SummaryBannerIconContainer>
        <CPPlusIcon />
      </SummaryBannerIconContainer>
      <SummaryBannerText>
        <em>{renderBannerText()}</em>
        {' '}
        <SummaryBannerLink href="/membership" target="_blank" onClick={onClick}>Learn More</SummaryBannerLink>
      </SummaryBannerText>
    </SummaryBannerContainer>
  )
}
